import React from "react";

function ITHero({ language = "en" }) {
  return (
    <section className="hero contact-hero">
      {/* الخلفية */}
      <div
        className="hero-slides"
        style={{
          backgroundImage: "url(/img/jr5.png)",
        }}
      />

      {/* العنوان */}
      <h1>{language === "ar" ? " خدمات تقنية المعلومات والجهد المنخفض (توريد وتركيب)" : "IT & Low Current Services (Supply & Installation)"}</h1>

      {/* العبارات الثابتة */}
      <div className="hero-texts">
        <div className="hero-text active">
          <p>
            {/* {language === "ar"
              ? "خدمات استشارية إدارية احترافية"
              : "Professional Management Consulting Services"} */}
          </p>
          <p>
            {language === "ar"
              ? " نصمم ونورد وننفذ حلول البنية التحتية التقنية وأنظمة الجهد المنخفض بما يتناسب مع احتياجات أعمالك"
              : "We design, supply, and install robust IT infrastructure and low-current systems tailored to your business needs."}
          </p>
        </div>
      </div>

      {/* الزر */}
      <a href="#contact" className="btn">
        {language === "ar" ? " أرسل طلباً" : "SEND A REQUEST"}
      </a>

      {/* Dot واحدة (اختياري) */}
      <div className="slider-dots">
        <div className="dot active" />
      </div>
    </section>
  );
}

export default ITHero;
